import React, { useState } from 'react';
import { LostPasswordLoader } from '../Loaders/LostPasswordLoader';
import { useNavigate } from 'react-router-dom';
import { InputValidation } from '../../models/InputValidation';
import useErrorPage from '../../hooks/useErrorPage';
import { validateEmail } from '../../helpers/Common';
import { TextInput } from '../Shared/Inputs/TextInput';
import { Button } from '../Shared/Buttons/Button';
import { postLostPasswordRequest } from '../../services/RecruiterService';
import { ResponseModel } from '../../models/ResponseModel';

interface Props {
    styles: any;
    openAlert(status: string, message: string): void;
}

export const LostPassword: React.FC<Props> = (props) => {
    const navigate = useNavigate();
    const [email, setEmail] = useState<string>("");
    const [validation, setValidation] = useState<InputValidation>();
    const [loading, setLoading] = useState<boolean>(false);
    const [toErrorPage] = useErrorPage();
    const styles = props.styles;

    const handleInputBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        const value = event.target.value;   
        validateInput(value);
    }

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setEmail(value);
        if(validation?.invalid){
            validateInput(value);
        }  
    }

    async function submitEmail(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        let isValidEmail = validation?.valid;
        if(!isValidEmail) {
            isValidEmail = validateInput(email);
        }      
        if(isValidEmail) {
            setLoading(true);
            await postLostPasswordRequest(email)
            .then((response: ResponseModel) => {
                setLoading(false);
                if(response.status) {            
                    navigate('/recruiter/account/login');
                    props.openAlert("success", response.message);
                }
                else {
                    props.openAlert("error", response.message);
                }
            })
            .catch((error) => {            
                toErrorPage(error);
            });
        }
    }
    
    const validateInput = (value: string): boolean => {
        if (value === "") {    
            setValidation({ valid: false, invalid: true, invalidMessage: "Email is required!" });
            return false;
        } else if (!validateEmail(value)) {   
            setValidation({ valid: false, invalid: true, invalidMessage: "Invalid email address!"});
            return false;           
        } else {
            setValidation({ valid: true, invalid: false });
            return true;  
        }     
    }

    return (
        <>
            {loading ? <LostPasswordLoader isRecruiter={true}/> : 
            <form style={{...styles.passwordForm, ...styles.passwordForm.lost}} onSubmit={submitEmail}>
                <h5 style={styles.title}>Lost Your Password?</h5>
                <p style={styles.subTitle}>Please enter your email address.</p>
                <TextInput
                    label={'Email *'}
                    inputType={'text'}
                    name={"email"}
                    value={email}
                    handleChange={handleInputChange}
                    validation={validation}
                    handleBlur={handleInputBlur}
                />
                <Button type="submit" style={{...styles.submitButton, ...styles.resetButton}}>{"SEND ME THE LINK"}</Button>
            </form>}
        </>
    )
}